import { PUT_REDUX_COMPANIES_LIST } from '../../reducers/constants';

const putReduxAllCompanies = (allCompanies) => ({
  type: PUT_REDUX_COMPANIES_LIST,
  allCompanies,
});
export default putReduxAllCompanies;
